import React, { useState, useEffect } from "react";
import { useSelector ,useDispatch} from 'react-redux';
import { useParams, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Spinner,
  Button,
  Tooltip,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";

import  ZendeskWidget  from "../../Components/CustomerSupport/ZendeskWidget";

//Simple bar
import SimpleBar from "simplebar-react";

import { ToastContainer, toast } from 'react-toastify';
import BreadCrumb from "../../Components/Common/BreadCrumb";

import { useMediaQuery } from'react-responsive';

import { Swiper, SwiperSlide } from "swiper/react";
import classnames from "classnames";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import EventBus from '../../utils/eventBus'; // 引入 EventBus
import  { FreeMode, Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper"; 

import { Link } from "react-router-dom";

import { fetchProductDetail,fetchReviews,fetchProductImg } from '../../utils/products';
import { API_BASE_URL } from '../../config';
import { addToCart } from '../../utils/cart';
import { getNfcByUid,nfcAll,nfcAdd,getProductNFC } from "../../utils/nfc";
import { getLoggedinUser } from '../../utils/api_helper_custom';
// import { fetchProductDetail } from "../../utils/products";

SwiperCore.use([FreeMode, Navigation, Thumbs]);


const PricingWidgetList = (props) => {
  return (
    <React.Fragment>
      <Col lg={3} sm={6}>
        <div className="p-2 border border-dashed rounded">
          <div className="d-flex align-items-center">
            <div className="avatar-sm me-2">
              <div className="avatar-title rounded bg-transparent text-primary fs-24">
                <i className={props.pricingDetails.icon}></i>
              </div>
            </div>
            <div className="flex-grow-1">
              <p className="text-muted mb-1">{props.pricingDetails.label} :</p>
              <h5 className="mb-0">{props.pricingDetails.labelDetail}</h5>
            </div>
          </div>
        </div>
      </Col>
    </React.Fragment>
  );
};

function countUP(id, prev_data_attr) {
  id(prev_data_attr + 1);
}

function countDown(id, prev_data_attr) {
  id(prev_data_attr - 1);
}
function ProductDetail(props) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [ttop, setttop] = useState(false);
 
  const [customActiveTab, setcustomActiveTab] = useState("1");

  const location = useLocation(); // Get current location
  const searchParams = new URLSearchParams(location.search);
  const productId = searchParams.get("productId"); // Extract productId from query params
  console.log('ProductId', productId);

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };
  
  
  const [defaultCounter, setdefaultCounter] = useState(1);
  const [loading, setLoading] = useState(true);
  const [detail, setDetailData ] = useState(null); 
  const [reviews, setReviewsData ] = useState(null);
  const [imgList, setImgList ] = useState([]);
  const [nfcId, setNfcId] = useState("");
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const successnotify = (message) => toast(message, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });

  // Check if current user can edit products (employee3 only)
  const canEditProduct = () => {
    const currentUser = getLoggedinUser();
    if (!currentUser) return false;
    return currentUser.role === 'employee3' || currentUser.user_type === 'employee3';
  };
 
    //fetch reviews 
    useEffect(() => {
      const loadReviewsData = async () => {
        try {
          const response = await fetchReviews(productId);
          if(response.status === 200) {
            setReviewsData(response.data);
          }else{
            errornotify(response.message || "Failed to get product detail. Please try again.")  
          }
        } catch (error) {
          console.error("Error loading reviews:", error);
        } finally {
          setLoading(false);
        }
      };
  
      loadReviewsData();
    }, []);

    //fetch detail 
    useEffect(() => {
      const loadDetailsData = async () => {
        try {
          const response = await fetchProductDetail(productId);  
          if(response.status === 200) {
            console.log('data', response.data); 
            loadProductNFC(response.data.product.id) 
            // const product_data = data.product?data.product:{};
            setDetailData(response.data.product);
          }else{
            errornotify(response.message || "Failed to get product detail. Please try again.")  
          }
        } catch (error) {
          console.error("Error loading details:", error);
        } finally {
          setLoading(false);
        }
      };
  
      loadDetailsData();
    }, []); 
    // Updated function to use customer-friendly NFC endpoint
    const loadProductNFC = async (productId) => {
      try {
        console.log('Loading NFC data for product:', productId);
        const response = await getProductNFC(productId);  
        
        if(response.status === 200 && response.data?.success){ 
          console.log('NFC response data:', response.data);
          if(response.data.data && response.data.data.length > 0){
            setNfcId(response.data.data[0].uid);
            console.log('NFC UID set:', response.data.data[0].uid);
          } else {
            console.log('No NFC tags found for this product');
            setNfcId(""); // Clear NFC ID if no tags found
          }
        }
        else {
          console.log('NFC API response:', response);
          // Don't show error notification for no NFC tags, as it's normal
          if (response.data?.message && !response.data?.message.includes('No NFC')) {
            errornotify(response.data?.message || 'Failed to fetch NFC data'); 
          }
          setNfcId(""); // Clear NFC ID on error
        }
      }
      catch (error) {
        console.error('Error fetching NFC data:', error); 
        // Don't show error notification for network issues when fetching NFC
        // as it's not critical for product display
        setNfcId(""); // Clear NFC ID on error
      }
    }
    //add to cart
    
    
    const data = useSelector((state) => state.cart);
    const dispatch = useDispatch();

    const handleAddToCart = async () => { 
      try {
        const response = await addToCart(productId, defaultCounter);  
         
        if(response.status === 200) {
          successnotify(response.message || "Add to cart successfully!");
          EventBus.emit('refresh', true); // 发布事件
        }else{
          errornotify(response.message || "Failed to get product img. Please try again.")  
        }  
      } catch (error) {
        errornotify(error.message || "Failed to add cart . Please try again.")  
      }  
    };
    
    //fetch img 
    useEffect(() => {
      const loadImgList = async () => {
        try {
          const response = await fetchProductImg(productId);   
          if(response.status === 200) {
            setImgList(response.data.images);
          }else{
            errornotify(response.message || "Failed to get product img. Please try again.")  
          } 
        } catch (error) {
          console.error("Error loading profile:", error);
        } finally {
          setLoading(false);
        }
      };
  
      loadImgList();
    }, []);
    
    if (loading) {
      return <div>Loading...</div>;
    }
  document.title = "Product Details | SeedNations";

  // 添加时间格式化函数
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };

  return (
    <div className="page-content">ZendeskWidget
      <ZendeskWidget />
      <Container fluid>
        
      <ToastContainer />
        <BreadCrumb title="Product Details" pageTitle="Ecommerce" />

        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <Row className="gx-lg-5">
                  <Col xl={4} lg={5} md={6} sm={12} className="mx-auto">
                    <div className="product-img-slider sticky-side-div">
                      <Swiper
                        navigation={true}
                        thumbs={{ swiper: thumbsSwiper }}
                        className="swiper product-thumbnail-slider p-2 rounded bg-light"
                      >
                        <div className="swiper-wrapper">

                          
                        {imgList?imgList.map((imgurl, index) => ( 
                            <SwiperSlide key={index}>
                              <img
                                src={API_BASE_URL + imgurl}
                                alt=""
                                className="img-fluid d-block"
                              />
                            </SwiperSlide> 
                          )):
                          <SwiperSlide>
                          <img
                            src={API_BASE_URL + "/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp"}
                            alt="default"
                            className="img-fluid d-block"
                          />
                        </SwiperSlide> }
                           
                        </div>
                      </Swiper>

                      <div className="product-nav-slider mt-2">
                        <Swiper
                          onSwiper={setThumbsSwiper}
                          slidesPerView={4}
                          freeMode={true}
                          watchSlidesProgress={true}
                          spaceBetween={10}
                          className="swiper product-nav-slider mt-2 overflow-hidden"
                        >
                          <div className="swiper-wrapper"> 
                          {imgList?imgList.map((imgurl, index) => ( 
                            <SwiperSlide key={index} className="rounded">
                              <div className="nav-slide-item">
                                <img
                                  src={API_BASE_URL + imgurl}
                                  alt=""
                                  className="img-fluid d-block rounded"
                                />
                              </div>
                            </SwiperSlide>
                            )) :<SwiperSlide>
                            <div className="nav-slide-item">
                              <img
                                src={API_BASE_URL + "/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp"}
                                alt=""
                                className="img-fluid d-block rounded"
                              />
                            </div>
                          </SwiperSlide>} 
                          </div>
                        </Swiper>
                      </div>
                    </div>
                  </Col>

                  <Col xl={8} lg={7} md={6} sm={12}>
                    <div className="mt-xl-0 mt-5">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h4>{detail?detail.name:""}</h4>
                          <div className="hstack gap-3 flex-wrap">
                            <div>
                              <Link to="#" className="text-primary d-block">
                              {detail?detail.brand:""}
                              </Link>
                            </div>
                            <div className="vr"></div>
                            <div className="text-muted">
                              NFC ID :{" "}
                              <span className="fw-medium">
                              {nfcId?nfcId:"No NFC ID"}
                              </span>
                            </div>  
                            <div className="vr"></div>
                            <div className="text-muted">
                              Seller :{" "}
                              <span className="fw-medium">
                              {detail?detail.brand:""}
                              </span>
                            </div>
                            <div className="vr"></div>
                            <div className="text-muted">
                              Published :{" "}
                              <span className="fw-medium">
                              {formatDateTime(detail?.created_at)}
                              </span>
                            </div>
                          </div>
                        </div>
                        {canEditProduct() && (
                          <div className="flex-shrink-0">
                            <div>
                              <Tooltip
                                placement="top"
                                isOpen={ttop}
                                target="TooltipTop"
                                toggle={() => {
                                  setttop(!ttop);
                                }}
                                transition={{ timeout: 150 }}
                                delay={{ show: 100, hide: 100 }}
                              >
                                Edit Product
                              </Tooltip>
                              <Link to={`/edit-product?productId=${detail?.id}`}
                                id="TooltipTop"
                                className="btn btn-light"
                              >
                                <i className="ri-pencil-fill align-bottom"> Edit Product</i>
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="d-flex flex-wrap gap-2 align-items-center mt-3">
                        <div className="text-muted fs-16">
                          <span className="mdi mdi-star text-warning"></span>
                          <span className="mdi mdi-star text-warning"></span>
                          <span className="mdi mdi-star text-warning"></span>
                          <span className="mdi mdi-star text-warning"></span>
                          <span className="mdi mdi-star text-warning"></span>
                        </div>
                        <div className="text-muted">
                          ( 5.50k Customer Review )
                        </div>
                      </div>

                      <Row className="mt-4  align-items-center ">  
                          <PricingWidgetList
                            pricingDetails={{
                              id: 1,
                              icon: "ri-money-dollar-circle-fill",
                              label: "Price",
                              labelDetail: `$${detail?detail.editions[0].price:0.00}`,
                            }}
                            key={1}
                          />
                        <PricingWidgetList
                            pricingDetails={{
                              id: 3,
                              icon: "ri-stack-fill",
                              label: "Available Stocks",
                              labelDetail: `${detail && detail.editions[0]?.inventory?.available_for_sale ? detail.editions[0].inventory.available_for_sale : (detail?.editions[0]?.total_units || 0)} units`,
                            }}
                            key={2}
                          /> 
                          <Col lg={3} md={6} sm={6} xs={12}>
                          <div className="input-step">
                            <button
                              type="button"
                              className="minus" 
                              disabled={defaultCounter <= 0}
                              onClick={() => {
                                if (defaultCounter > 0) {
                                  countDown(setdefaultCounter, defaultCounter);
                                }
                              }}
                            >
                              –
                            </button>
                            <Input
                              type="number"
                              className="product-quantity"
                              value={defaultCounter}
                              min="0"
                              max={detail && detail.editions[0]?.inventory?.available_for_sale ? detail.editions[0].inventory.available_for_sale : (detail?.editions[0]?.total_units || 100)}
                              readOnly
                            />
                            <button
                              type="button"
                              className="plus"
                              disabled={defaultCounter >= (detail && detail.editions[0]?.inventory?.available_for_sale ? detail.editions[0].inventory.available_for_sale : (detail?.editions[0]?.total_units || 100))}
                              onClick={() => {
                                const maxStock = detail && detail.editions[0]?.inventory?.available_for_sale ? detail.editions[0].inventory.available_for_sale : (detail?.editions[0]?.total_units || 100);
                                if (defaultCounter < maxStock) {
                                  countUP(setdefaultCounter, defaultCounter);
                                }
                              }}
                            >
                              +
                            </button>
                          </div>
                        </Col>
                        <Col lg={3} md={6} sm={6} xs={12}>
                          {(() => {
                            const availableStock = detail && detail.editions[0]?.inventory?.available_for_sale ? detail.editions[0].inventory.available_for_sale : (detail?.editions[0]?.total_units || 0);
                            const isOutOfStock = availableStock <= 0;
                            const isLowStock = availableStock > 0 && availableStock <= 5;
                            
                            return (
                              <>
                                {isOutOfStock ? (
                                  <Button color="danger" className="btn btn-danger w-100" disabled>
                                    <i className="ri-close-circle-line me-1"></i>
                                    Out of Stock
                                  </Button>
                                ) : (
                                  <Button color="success" className="btn btn-success w-100" onClick={handleAddToCart}>
                                    {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : null}
                                    <i className="ri-shopping-cart-line me-1"></i>
                                    Add to Cart
                                  </Button>
                                )}
                                {isLowStock && !isOutOfStock && (
                                  <div className="mt-2">
                                    <small className="text-warning">
                                      <i className="ri-alert-line me-1"></i>
                                      Only {availableStock} left in stock!
                                    </small>
                                  </div>
                                )}
                              </>
                            );
                          })()}
                        </Col>
                      </Row> 


                      <Row>
                        <Col  lg={10}  sm={12}>
                          <div className="mt-4 text-muted">
                            <h5 className="fs-14">Back Story :</h5>
                            <div dangerouslySetInnerHTML={{ __html: detail?detail.description:"" }} />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} sm={12}>
                          <div className="mt-3">
                            <h5 className="fs-14">Description :</h5>
                            <p>
                            {detail?detail.short_description:""}
                            </p>
                          </div>
                        </Col>
                        <Col md={6} sm={12}>
                          <div className="mt-3">
                            <h5 className="fs-14">Services :</h5>
                            <ul className="list-unstyled product-desc-list">
                              <li className="py-1">10 Days Replacement</li>
                              <li className="py-1">
                                Cash on Delivery available
                              </li>
                            </ul>
                          </div>
                        </Col>
                      </Row>

                      <div className="product-content mt-5">
                        <Nav tabs className="nav-tabs-custom nav-primary">
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "1",
                              })}
                              onClick={() => {
                                toggleCustom("1");
                              }}
                            >
                              Specification
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: customActiveTab === "2",
                              })}
                              onClick={() => {
                                toggleCustom("2");
                              }}
                            >
                              Details
                            </NavLink>
                          </NavItem>
                        </Nav>

                        <TabContent
                          activeTab={customActiveTab}
                          className="border border-top-0 p-4"
                          id="nav-tabContent"
                        >
                          <TabPane
                            id="nav-speci"
                            tabId="1"
                          >
                            <div className="table-responsive">
                              <table className="table mb-0">
                                <tbody>
                                  <tr>
                                    <th scope="row" style={{ width: "200px" }}>
                                      Category
                                    </th>
                                    <td> {detail?detail.category:""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Brand</th>
                                    <td> {detail?detail.brand:""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Color</th>
                                    <td> {detail?detail.editions[0].color:""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Material</th>
                                    <td>{detail?detail.editions[0].material:""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Weight</th>
                                    <td>{detail?(detail.editions[0].weight?detail.editions[0].weight:0):""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Series</th>
                                    <td>{detail?detail.editions[0].edition_name:""}</td>
                                  </tr>

                                  <tr>
                                    <th scope="row">NFT</th>
                                    <td>{detail?detail.editions[0].nft?"Yes":"No":"No"}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">NFT Link</th>
                                    <td>{detail?detail.editions[0].nft_link:""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Battery Required</th>
                                    <td>{detail?detail.editions[0].battery_required?"Yes":"No":"No"}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Baterry Type</th>
                                    <td>{detail?detail.editions[0].battery_type:""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Battery Capacity</th>
                                    <td>{detail?detail.editions[0].battery_capacity:""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Age Limit</th>
                                    <td>{detail?detail.editions[0].age_limit:""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Genre</th>
                                    <td>{detail?.genres ? detail.genres.map(genre => genre).join(', ') : ""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Artist</th>
                                    <td>{detail?detail.editions[0].artist:""}</td>
                                  </tr> 
                                  <tr>
                                    <th scope="row">Artist Link</th>
                                    <td>{detail?detail.editions[0].artist_link:""}</td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Total Units</th>
                                    <td>{detail?detail.editions[0].total_units:0}</td>
                                  </tr>
                                  {detail?.editions[0]?.inventory && (
                                  <tr>
                                    <th scope="row">Available Stock</th>
                                    <td>
                                      <span className="badge bg-success-subtle text-success">
                                        {detail.editions[0].inventory.available_for_sale} units available
                                      </span>
                                    </td>
                                  </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </TabPane>
                          <TabPane
                            id="nav-detail"
                            tabId="2"
                          >
                            <div>
                              <h5 className="font-size-16 mb-3">
                                {detail?detail.name:""}
                              </h5>
                              <p
                                dangerouslySetInnerHTML={{ __html: detail ? detail.description : "" }}
                              />

                            </div>
                          </TabPane>
                        </TabContent>
                      </div>

                      <div className="mt-5">
                        <div>
                          <h5 className="fs-14 mb-3">Ratings & Reviews</h5>
                        </div>
                        <Row className="gy-4 gx-0">
                        { isMobile? <Col  lg={4} md={12} sm={12}>
                            <div>
                              <div className="pb-3">
                                <div className="bg-light px-3 py-2 rounded-2 mb-2">
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <div className="fs-16 align-middle text-warning">
                                        <i className="ri-star-fill"></i>{" "}
                                        <i className="ri-star-fill"></i>{" "}
                                        <i className="ri-star-fill"></i>{" "}
                                        <i className="ri-star-fill"></i>{" "}
                                        <i className="ri-star-half-fill"></i>
                                      </div>
                                    </div>
                                    <div className="flex-shrink-0">
                                      <h6 className="mb-0">4.5 out of 5</h6>
                                    </div>
                                  </div>
                                </div>
                                <div className="text-center">
                                  <div className="text-muted">
                                    Total{" "}
                                    <span className="fw-medium">5.50k</span>{" "}
                                    reviews
                                  </div>
                                </div>
                              </div>

                              <div className="mt-3">
                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">5 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-primary"
                                          role="progressbar"
                                          style={{ width: "50.16%" }}
                                          aria-valuenow="50.16"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">2758</h6>
                                    </div>
                                  </div>
                                </Row>

                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">4 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-success"
                                          role="progressbar"
                                          style={{ width: "19.32%" }}
                                          aria-valuenow="19.32"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">1063</h6>
                                    </div>
                                  </div>
                                </Row>

                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">3 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-secondary"
                                          role="progressbar"
                                          style={{ width: "18.12%" }}
                                          aria-valuenow="18.12"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">997</h6>
                                    </div>
                                  </div>
                                </Row>

                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">2 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-warning"
                                          role="progressbar"
                                          style={{ width: "7.42%" }}
                                          aria-valuenow="7.42"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">408</h6>
                                    </div>
                                  </div>
                                </Row>

                                <Row className="align-items-center g-2">
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0">1 star</h6>
                                    </div>
                                  </div>
                                  <div className="col">
                                    <div className="p-2">
                                      <div className="progress animated-progess progress-sm">
                                        <div
                                          className="progress-bar bg-danger"
                                          role="progressbar"
                                          style={{ width: "4.98%" }}
                                          aria-valuenow="4.98"
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-auto">
                                    <div className="p-2">
                                      <h6 className="mb-0 text-muted">274</h6>
                                    </div>
                                  </div>
                                </Row>
                              </div>
                            </div>
                          </Col> : null}
                          

                           <Col lg={isMobile?8:12} md={12} sm={12}>  
                            <div className="ps-lg-4">
                              <div className="d-flex flex-wrap align-items-start gap-3">
                                <h5 className="fs-14">Reviews: </h5>
                              </div>

                              <SimpleBar
                                className="me-lg-n3 pe-lg-4"
                                style={{ maxHeight: "225px" }}
                              >
                                <ul className="list-unstyled mb-0">
                                  {reviews?reviews.reviews.map((review, key) => (
                                    <React.Fragment key={key}>
                                      <ProductReview review={review} />
                                    </React.Fragment>
                                  )):""}
                                </ul>
                              </SimpleBar>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ProductDetail;
